import { View, Text } from 'react-native'
import { ThemedText, ThemedView } from '@app/theme'
import Button from '@app/sharedComponents/Button/Button'
import SystemWarning from '@app/assets/svg/SystemWarning'

const BankIfscUnsupportedModal = () => {
  return (
    <ThemedView padding='lg' justifyContent='center' alignItems='center'>
      <SystemWarning size={48} />
      <ThemedView mt='md' mb='2xl'>
        <ThemedText textAlign='center' variant='b2b' color='text-primary'>Selected bank account does not {'\n'} support digital mandate</ThemedText>
      </ThemedView>

      <Button size='MD' label='Change bank account' handlePress={() => { }} bg='#1434CB' textColor='text-primary' />
    </ThemedView>
  )
}

export default BankIfscUnsupportedModal